import React from "react";
import { Section, Eyebrow, SectionTitle } from "@/components/Primitives";
import { ShieldCheck, Users, Building2, Award } from "lucide-react";

const ESTATE = "https://images.unsplash.com/photo-1575281923032-f40d94ef6160?crop=entropy&cs=srgb&fm=jpg&q=85";

const About = () => (
  <div>
    <div className="relative eti-grid-bg border-b border-white/10 py-20">
      <Section>
        <Eyebrow>About Exclusive Trades Inc</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-white max-w-3xl leading-[1.05]">
          Building The One-Stop Marketplace For Every Trade
        </h1>
        <p className="mt-6 text-lg text-slate-300 max-w-2xl leading-relaxed">
          We exist to remove the friction, risk and guesswork from construction and real estate. One platform to connect, verify, deliver and track — from the first quote to the final payout.
        </p>
      </Section>
    </div>

    <Section className="py-16 grid lg:grid-cols-2 gap-10 items-center">
      <div className="rounded-2xl overflow-hidden h-80"><img src={ESTATE} alt="" className="w-full h-full object-cover" /></div>
      <div>
        <Eyebrow>Our Mission</Eyebrow>
        <SectionTitle>Reputable Work, Every Single Time</SectionTitle>
        <p className="mt-4 text-slate-300 leading-relaxed">
          Homeowners deserve reputable contractors. Contractors deserve fair, steady work. Laborers deserve access to gigs. Realtors and investors deserve deal-ready connections. And drivers deserve to monetize their vehicles. Exclusive Trades Inc aligns all of them under one roof — with safety compliance and transparent fees baked in.
        </p>
        <p className="mt-4 text-slate-300 leading-relaxed">
          Every contractor is required to submit WSIB and liability insurance before they can reach customers. That's non-negotiable — because trust is the foundation we build on.
        </p>
      </div>
    </Section>

    <Section className="py-8">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          [Users, "12,400+", "Members across 5 roles"],
          [ShieldCheck, "100%", "Contractors WSIB verified"],
          [Building2, "$2.4M", "Tracked in project payouts"],
          [Award, "4.9/5", "Average platform rating"],
        ].map(([Icon, n, d], i) => (
          <div key={i} className="eti-card rounded-lg p-6 text-center" data-testid={`about-stat-${i}`}>
            <Icon className="h-7 w-7 text-primary mx-auto" />
            <p className="font-display text-3xl font-bold text-white mt-3">{n}</p>
            <p className="text-sm text-slate-400 mt-1">{d}</p>
          </div>
        ))}
      </div>
    </Section>

    <Section className="py-16">
      <Eyebrow>Our Journey</Eyebrow>
      <SectionTitle>The Road So Far</SectionTitle>
      <div className="mt-8 space-y-6">
        {[
          ["2021", "Founded", "Exclusive Trades Inc launches to connect homeowners with vetted local contractors."],
          ["2023", "Cargo Delivery Board", "We add cargo van & Sprinter drivers to haul materials from suppliers to job sites."],
          ["2024", "Real Estate Hub", "Realtors and investors join to buy, sell, rent and flip properties on-platform."],
          ["2025", "Milestone Escrow & Tracking", "End-to-end progress tracking from Requested to Payment Released goes live."],
        ].map(([y, t, d], i) => (
          <div key={i} className="flex gap-6 items-start" data-testid={`about-timeline-${i}`}>
            <span className="font-mono text-primary font-bold text-lg w-16 shrink-0">{y}</span>
            <div className="border-l border-white/10 pl-6 pb-2">
              <p className="font-display font-bold text-white uppercase">{t}</p>
              <p className="text-sm text-slate-400 mt-1">{d}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  </div>
);

export default About;
